import { getDeepProperty } from '@/helpers/deepObject.js'

// sometimes we needd to show defaultAccount because we can't view a show via the Org lense
export default {
  getPodcastAccountUI (podcast, accounts, defaultAccount) {
    const accountId = getDeepProperty(podcast, 'account.id')
    if (!accountId || !accounts.find((a) => a.id === accountId)) return defaultAccount.id
    return accountId
  }
}
